export const QA_NAME_CALENDAR_GRID_DAY_POPOVER_COMPACT_ROW =
  'calendarGridDayPopoverCompactRow'

export const QA_NAME_CALENDAR_GRID_DAY_POPOVER_COMPACT_ROW_SECONDARY_LABEL =
  'calendarGridDayPopoverCompactRowSecondaryLabel'
